import * as React from 'react';
import useToggle from 'core/hooks/useToggle';
import { FaqItem } from 'lib/types';
import parse from 'html-react-parser';
import classnames from 'classnames';
import * as styles from './FAQ.module.scss';
import Expander from '../Expander';

export type FAQProps = {
    faqItems: ReadonlyArray<FaqItem>;
    initiallyActive?: string | undefined;
    title?: string;
    classes?: Partial<typeof styles>;
};

function FAQ({ faqItems, title, initiallyActive, classes }: FAQProps) {
    const [activeItem, toggleActiveItem] = useToggle(initiallyActive);

    return (
        <section>
            <div className={classnames(styles.root, classes?.root)}>
                {!!title && (
                    <h2 className={classnames(styles.title, classes?.title)}>
                        {title}
                    </h2>
                )}
                <div className={classnames(styles.grid, classes?.grid)}>
                    {faqItems.map(({ title: itemTitle, text, id }) => (
                        <Expander
                            onClick={() => toggleActiveItem(id)}
                            open={id === activeItem}
                            title={itemTitle}
                            key={id}
                        >
                            {typeof text === 'string' ? parse(text) : text}
                        </Expander>
                    ))}
                </div>
            </div>
        </section>
    );
}

FAQ.defaultProps = {
    hideTitle: false,
};

export default FAQ;
